(function(){
/* --------------------------------------------------------------------------
   MOUNT — footer Custom Liquid renders below the footer, which is not where a
   page body belongs. Relocate the root into the theme's main content region and
   hide the legacy .page-marketing section it replaces.

   `.page-marketing` is the existing /pages/store-kit section (hero carousel,
   "Merchandising Kit May Include" grid, the "See more" button Eddie asked us to
   drop). It is HIDDEN rather than removed so a rollback is just deleting the
   footer block — nothing about the original page template is destroyed.
   -------------------------------------------------------------------------- */
function mount(){
  /* A Custom Liquid block renders inside a <section class="shopify-section"> that the
     theme gives ~92px of padding. Moving our root out leaves that wrapper behind as a
     block of empty space between the page and the footer — 276px of it when the block
     has been pasted more than once, which is exactly what happened while iterating on
     this. So: collapse EVERY wrapper we own, and tolerate duplicates rather than
     assuming the block appears exactly once. */
  var roots = document.querySelectorAll("#kp-store-kit-root");
  if(!roots.length) return false;
  var main = document.getElementById("MainContent") ||
             document.querySelector("main") ||
             document.querySelector("#shopify-section-main, .main-content");
  if(!main) return false;

  for(var i = 0; i < roots.length; i++){
    var wrap = roots[i].parentElement;
    while(wrap && wrap !== document.body && !/\bshopify-section\b/.test(wrap.className || "")){
      wrap = wrap.parentElement;
    }
    if(wrap && wrap !== document.body) wrap.style.display = "none";
    /* Duplicate IDs are invalid HTML and break querySelector for everything after the
       first. Drop the extras instead of leaving them to collide. */
    if(i > 0) roots[i].parentNode && roots[i].parentNode.removeChild(roots[i]);
  }

  var root = roots[0];
  var legacy = main.querySelector(".page-marketing");
  if(legacy){ legacy.style.display = "none"; legacy.setAttribute("data-kp-replaced","1"); }
  main.appendChild(root);            // move out of the footer, into the page
  root.removeAttribute("hidden");
  root.style.display = "";           // wrapper was hidden above; the root itself must show
  return true;
}
if(!mount()){
  /* Theme markup not ready yet (deferred sections). Try again on DOM ready. */
  document.addEventListener("DOMContentLoaded", mount);
}

"use strict";

/* ============================================================================
   DATA
   ---------------------------------------------------------------------------
   MBOX_ITEMS mirrors retail.kingpalm.com's Marketing Box picker, MINUS the neon
   sign. Eddie, 2026-08-03 (voice note): "confirm, remove the neon sign. Do not
   add the neon sign. Everything else, they can easily add t-shirts and all that,
   but do not have the neon sign." It is removed from the picker, the preview
   grid and the SKU list — not merely hidden, so it cannot come back by accident.

   `def:true` = pre-selected, matching the 10 retail defaults minus neon (9).
   Pre-selecting is deliberate: a retailer who taps straight through still gets a
   full counter set, and the picker reads as "here's your kit, adjust it" rather
   than "build one from nothing".
   ========================================================================== */
var MBOX_ITEMS = [
  {k:"woodensign",     label:"Wooden sign",   def:true},
  {k:"floor-mats",     label:"Floor mat",     def:true},
  {k:"floorstand",     label:"Floor stand",   def:true},
  {k:"floor-stickers", label:"Floor stickers",def:true},
  {k:"shelf-talker",   label:"Shelf talker",  def:true},
  {k:"stickers",       label:"Stickers",      def:true},
  {k:"Posters",        label:"Poster",        def:true},
  {k:"Flyers",         label:"Flyers",        def:true},
  {k:"table-tents",    label:"Table tent",    def:true},
  {k:"clocks",         label:"Wall clock"},
  {k:"Inflatables",    label:"Inflatable"},
  {k:"dealcards",      label:"Deal cards"},
  {k:"Aisle-blades",   label:"Aisle blade"},
  {k:"paper-trays",    label:"Paper tray"},
  {k:"t-shirts",       label:"T-shirt"},
  {k:"hats",           label:"Hat"},
  {k:"free-sample",    label:"Free samples"}
];

var BIZ = [
  ["smoke",      "Smoke shop",  "Head / vape / tobacco"],
  ["liquor",     "Liquor store","Beer · wine · spirits"],
  ["dispensary", "Dispensary",  "Licensed cannabis retail"],
  ["other",      "Something else","Convenience, grocery, other retail"]
];

/* The form. One question per screen, same shape as the retail signup's APPLY_ALL.
   Differences from the old /pages/store-kit-request form, all from Eddie's note:
     - ONE address. The old form asked for a mailing address AND a shop address.
       "The mailing address should be the same as the shop address. So you don't
       need to enter this in twice."
     - Star rating REMOVED ("remove rate your experience").
     - Free-text experience KEPT and reframed — "this is useful... we can use
       these as like actual review cards."
     - Added: where they source product, and how many KP displays/SKUs they carry.
     - No password, no account creation. This path stays on kingpalm.com. */
var STEPS = [
  {k:"biz",      type:"text",   q:"What's your shop called?", ph:"e.g. Sunset Smoke & Vape", req:true},
  {k:"type",     type:"choice", q:"What kind of shop is it?", req:true},
  {k:"addr",     type:"address",q:"Where should we ship the kit?",
                 sub:"Your shop address. We ship the kit here — there's no separate mailing address to fill in.", req:true},
  {k:"locations",type:"text",   mode:"numeric", q:"How many locations do you have?", ph:"e.g. 1",
                 sub:"How many storefronts you'd stock King Palm in.", req:true},
  {k:"contact",  type:"text",   q:"Who runs the counter?", ph:"Contact name", req:true},
  {k:"email",    type:"email",  q:"Best email for the shop?", ph:"you@shop.com", req:true,
                 sub:"We send kit tracking and order updates here."},
  {k:"phone",    type:"tel",    q:"Best number to reach you on?", ph:"(555) 123-4567", req:true},
  {k:"source",   type:"text",   q:"Where do you order King Palm from?",
                 ph:"Distributor, cash & carry, direct…",
                 sub:"So we route you to the right rep instead of guessing."},
  {k:"displays", type:"text",   mode:"numeric", q:"How many King Palm displays do you carry?",
                 ph:"e.g. 4", sub:"Rough count is fine — SKUs or displays, whichever you think in."},
  /* Shown ONLY when a T-shirt is in the box — see steps(). Before this, KP-MB-TSHIRT was
     one sizeless SKU and every kit shipped with a "confirm the size" note on the packing
     slip that nobody could action without phoning the shop. Eddie, 2026-08-04: "Retailer
     picks what sizes and how many with a max of 5 shirts." */
  {k:"tees",     type:"sizes",  q:"What sizes, and how many?",
                 sub:"Up to 5 shirts, mixed however you like. Sizes run unisex.", req:true},
  {k:"exp",      type:"long",   q:"How’s King Palm doing for you?", opt:true,
                 ph:"What sells, what doesn’t, what your customers ask for…",
                 sub:"Honest answers help more than nice ones. We may quote you — tell us if you’d rather we didn’t."},
  {k:"confirm",  type:"confirm",q:"Last thing — confirm and we'll ship it.", req:true}
];

/* ============================================================================
   STATE
   ========================================================================== */
var ICONS = window.KP_MBOX_ICONS || {};
var S = {
  stage:"home",        // home | picker | form | done
  step:0,
  mats:{},             // label -> true
  form:{country:"United States"},
  err:"",
  sending:false
};
MBOX_ITEMS.forEach(function(it){ if(it.def) S.mats[it.label]=true; });

var app = document.getElementById("kp-store-kit-root");
function esc(s){ return String(s==null?"":s).replace(/[&<>"']/g,function(c){
  return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); }
function count(){ return Object.keys(S.mats).filter(function(k){return S.mats[k];}).length; }
function picked(){ return MBOX_ITEMS.filter(function(it){return S.mats[it.label];}).map(function(it){return it.label;}); }
function iconOf(it){
  return ICONS[it.k]
    ? '<img src="'+ICONS[it.k]+'" alt="" loading="lazy">'
    : '<span aria-hidden="true" style="font-size:26px;opacity:.35">▢</span>';
}

/* ============================================================================
   VIEWS
   ========================================================================== */
function itemGrid(interactive){
  var cards = MBOX_ITEMS.map(function(it){
    var sel = !!S.mats[it.label];
    var tick = interactive ? (sel ? "✓ In box" : "Add") : "";
    var tag  = interactive ? "button" : "div";
    var attrs = interactive
      ? ' type="button" data-mbox="'+esc(it.label)+'" aria-pressed="'+(sel?"true":"false")+'"'
      : "";
    return '<'+tag+' class="icard'+(sel&&interactive?' sel':'')+'"'+attrs+'>'+
             '<div class="im">'+iconOf(it)+'</div>'+
             '<div class="lb">'+esc(it.label)+'</div>'+
             (tick?'<div class="tick">'+tick+'</div>':'')+
           '</'+tag+'>';
  }).join("");
  return '<div class="igrid'+(interactive?'':'')+'">'+cards+'</div>';
}

function home(){
  return ''+
  '<header class="hero"><div class="wrap"><div class="grid">'+
    '<div class="copy">'+
      '<span class="eyebrow">Retailer Merchandising Kit</span>'+
      '<h1>Stock King Palm. <br>We’ll dress the shelf.</h1>'+
      '<p class="lede">Signage, floor mats, displays and counter material — free, shipped to your '+
        'shop, no rep visit needed. Pick what you actually have room for.</p>'+
      '<div class="cta-row">'+
        '<button class="btn btn-gold" data-go="picker">Claim my free kit →</button>'+
        '<a class="btn btn-onblack" href="#kit">See what’s in it</a>'+
      '</div>'+
      '<div class="proof">'+
        '<div><b>17</b>pieces to choose from</div>'+
        '<div><b>$0</b>free with your order</div>'+
        '<div><b>Next day</b>ships from our warehouse</div>'+
      '</div>'+
    '</div>'+
    '<div class="shot"><img src="https://cdn.shopify.com/s/files/1/0883/8414/3656/files/marketing-banner.webp?v=1757318584" alt="King Palm product wall in a retail shop"></div>'+
  '</div></div></header>'+

  '<section class="vals"><div class="wrap"><div class="row">'+
    '<div class="val"><div class="n">01</div><h3>Free display kit</h3>'+
      '<p>Signage, floor mats and branding that make the King Palm set findable from the door.</p></div>'+
    '<div class="val"><div class="n">02</div><h3>Boost sell-through</h3>'+
      '<p>Best sellers at the front, high-margin SKUs at eye level, fast turnover on the shelf.</p></div>'+
    '<div class="val"><div class="n">03</div><h3>Exclusive perks</h3>'+
      '<p>Brand support, retailer rewards and incentives once you’re in the programme.</p></div>'+
  '</div></div></section>'+

  '<section class="sec" id="kit"><div class="wrap">'+
    '<div class="sec-hd"><h2>What’s in the kit</h2>'+
    '<p>Everything below is on the table — no catalogue to dig through. Tap through to the next '+
    'step and choose the pieces that fit your counter.</p></div>'+
    itemGrid(false)+
  '</div></section>'+

  '<section class="sec" style="padding-top:0"><div class="wrap"><div class="band">'+
    '<div><h3>Join thousands of retailers nationwide.</h3>'+
    '<p>Build your box, tell us where to send it, and it ships with your next order.</p></div>'+
    '<button class="btn btn-gold" data-go="picker">Claim my free kit →</button>'+
  '</div></div></section>';
  /* The "Distributed exclusively by Cannatron" strip was removed here (Eddie,
     2026-08-03). The theme footer already carries Cannatron under "CARRIED BY",
     so on this page it was a second, weaker statement of the same thing sitting
     between the CTA and the footer — and a distributor logo is not what should
     follow the ask on a page whose whole job is getting the retailer to click. */
}

function picker(){
  var n = count();
  return ''+
  '<section class="sec"><div class="wrap">'+
    '<button class="tf-back" style="margin:0 0 18px" data-go="home">↑ Back</button>'+
    '<div class="sec-hd"><h2>Build your Marketing Box</h2>'+
    '<p>Free with your order. Tap what you want on the counter — it ships in the same carton as '+
    'your displays, no rep inventory needed. We’ve pre-picked the set most shops keep.</p></div>'+
    '<div class="picker">'+itemGrid(true)+'</div>'+
  '</div>'+
  '<div class="pickbar"><div class="wrap"><div class="inner">'+
    '<div><div class="cnt"><b>'+n+'</b> '+(n===1?"item":"items")+' in your box</div>'+
    '<div class="mini">Your picks ride along free with your next order.</div></div>'+
    '<button class="btn btn-ink" data-go="form"'+(n?"":" disabled")+'>Add Marketing Box to my order →</button>'+
  '</div></div></div>'+
  '</section>';
}

/* Sizes and the cap live here AND in the API. The API is the one that counts — this page
   is cached on kingpalm.com, so a client-side cap is a suggestion, not a rule. Keep the
   two in step: TSHIRT_SIZES / MAX_TSHIRTS in kp-wholesale-flow/api/_kit-order.js. */
var TEE_SIZES = [["S","Small"],["M","Medium"],["L","Large"],["XL","XL"],["2XL","2XL"]];
var MAX_TEES  = 5;

/* The steps a given request actually has. The size question only exists when a T-shirt is
   in the box, so the array is filtered rather than fixed — otherwise the progress bar
   counts a step most retailers never see, and "9 → 12" lies to them. */
function steps(){
  return STEPS.filter(function(s){ return s.type!=="sizes" || picked().indexOf("T-shirt")>-1; });
}
/* ==========================================================================
   ADDRESS AUTOCOMPLETE + VERIFICATION

   Ported from the signup flow (retail.kingpalm.com/index.html), which has had
   these three endpoints since 2026-07-27. This form did NOT have them: it is
   served from kingpalm.com and calls retail.kingpalm.com cross-origin, and the
   address endpoints carried no CORS headers, so the browser blocked them
   outright. Every kit therefore shipped to whatever was typed — the Lifestyles
   request arrived as "Waterbury, ct 06704" and only ShipStation caught it,
   after the order already existed.

   IT NEVER BLOCKS. If the API is off, restricted, or unreachable, whatever the
   retailer typed is kept and the flow carries on. A free poster is not worth
   failing a form over.
   ========================================================================== */
function addrApi(){
  /* Same origin as the submit endpoint, so there is one thing to configure and
     it cannot point at a different environment than the POST does. */
  if(window.KP_ADDR_API) return window.KP_ADDR_API;
  var e = window.KP_STORE_KIT_ENDPOINT || "";
  return e ? e.replace(/\/store-kit\/?$/, "") : "";
}

var _acTimer=null, _acSeq=0;
function acSuggest(q){
  var box=document.getElementById("acsug"); if(!box) return;
  if(!addrApi() || !q || q.trim().length<3){ if(box) box.innerHTML=""; return; }
  clearTimeout(_acTimer);
  /* Sequence number, not just a debounce: a slow response for "858 L" must not
     overwrite the list for "858 Lakewood" typed after it. */
  var seq=++_acSeq;
  _acTimer=setTimeout(function(){
    fetch(addrApi()+"/address-suggest?q="+encodeURIComponent(q))
      .then(function(r){ return r.json(); })
      .then(function(j){
        if(seq!==_acSeq) return;
        var b=document.getElementById("acsug"); if(!b) return;
        b.innerHTML=((j&&j.suggestions)||[]).slice(0,5).map(function(s){
          return '<button type="button" class="acitem" data-acpick="'+esc(s.placeId)+'">'+
            '<b>'+esc(s.main||"")+'</b>'+(s.secondary?'<span>'+esc(s.secondary)+'</span>':"")+'</button>';
        }).join("");
      })
      .catch(function(){});
  },250);
}
function acPick(placeId){
  fetch(addrApi()+"/address-details?id="+encodeURIComponent(placeId))
    .then(function(r){ return r.json(); })
    .then(function(j){
      if(!(j&&j.ok&&j.address)) return;
      var a=j.address;
      /* syncInputs FIRST: the suite/unit field may hold something typed but not
         yet committed to state, and re-rendering would throw it away. */
      syncInputs();
      S.form.addr=a.address1||""; S.form.city=a.city||"";
      S.form.state=a.state||"";   S.form.zip=a.zip||"";
      /* Clear any open panel, but do NOT mark this address as verified. A Places
         prediction is a street, not a confirmed deliverable address — it carries no
         suite, and the retailer can still hand-edit it afterwards. Setting
         addrCheckFor here made picking a suggestion silently skip verification
         entirely, which is the exact hole this feature exists to close. */
      S.addrCheck=null;
      var b=document.getElementById("acsug"); if(b) b.innerHTML="";
      render();
    })
    .catch(function(){});
}

function addrKey(){
  var f=S.form;
  return [f.addr,f.addr2,f.city,f.state,f.zip].join("|").toLowerCase().replace(/\s+/g," ").trim();
}
/* Run on SUBMIT of the address step. Autocomplete helps while they type; this
   catches what they actually send — someone typing fast, or hand-editing after
   picking from the dropdown, still lands a bad address on a real shipment. */
function checkAddress(done){
  if(!addrApi()){ done(); return; }
  var key=addrKey();
  S.addrChecking=true; S.addrCheck=null; render();
  fetch(addrApi()+"/address-validate",{
    method:"POST", headers:{"Content-Type":"application/json"},
    body:JSON.stringify({address1:S.form.addr,address2:S.form.addr2,city:S.form.city,
                         state:S.form.state,zip:S.form.zip,country:"US"})
  })
    .then(function(r){ return r.json(); })
    .then(function(j){ resolveAddr(j||{}, key, done); })
    .catch(function(){ resolveAddr({status:"not_configured"}, key, done); });
}
function resolveAddr(j, key, done){
  S.addrChecking=false;
  /* Only "corrected" and "unconfirmed" are worth interrupting someone for. A clean
     match, or an API that is not switched on, carries straight through. */
  if(j.status==="corrected" || j.status==="unconfirmed"){ S.addrCheck=j; render(); return; }
  S.addrCheck=null; S.addrCheckFor=key; done();
}
function addrPanel(){
  var j=S.addrCheck; if(!j) return "";
  var s=j.suggested||{}, corrected=(j.status==="corrected");
  var l1=[s.address1,s.address2].filter(Boolean).join(", ");
  var l2=[[s.city,s.state].filter(Boolean).join(", "),s.zip].filter(Boolean).join(" ");
  var why = corrected
    ? "We found a slightly different match. Using the verified version means fewer delivery problems."
    : "We couldn’t fully verify this address. Double-check it, or carry on if you know it’s right.";
  return '<div class="addrchk'+(corrected?"":" warn")+'" role="status">'+
    '<div class="ac-h">'+(corrected?"Use the verified address?":"Check this address")+'</div>'+
    '<div class="ac-why">'+esc(why)+'</div>'+
    (corrected&&l1?'<div class="ac-sug">'+esc(l1)+'<br>'+esc(l2)+'</div>':"")+
    '<div class="ac-btns">'+
      (corrected&&l1?'<button type="button" class="btn btn-ink ac-b" data-act="addr-use">Use this one</button>':"")+
      '<button type="button" class="btn btn-ghost ac-b" data-act="addr-keep">Keep what I typed</button>'+
    '</div></div>';
}

function tees(){ return S.form.tees || (S.form.tees = {}); }
/* "1 × Small, 2 × Large" — empty string when there is nothing to say, so callers
   can use it directly as a truthiness test. */
function teeSummary(){
  return TEE_SIZES.filter(function(s){ return (parseInt(tees()[s[0]],10)||0) > 0; })
                  .map(function(s){ return (parseInt(tees()[s[0]],10)||0)+" × "+s[1]; })
                  .join(", ");
}
function teeTotal(){
  return TEE_SIZES.reduce(function(n,s){ return n + (parseInt(tees()[s[0]],10)||0); }, 0);
}

function stepCtrl(st){
  var f = S.form;
  if(st.type==="sizes"){
    var total = teeTotal(), full = total >= MAX_TEES;
    return '<div class="tf-sizes">'+TEE_SIZES.map(function(s){
      var n = parseInt(tees()[s[0]],10)||0;
      return '<div class="tf-size'+(n?" on":"")+'">'+
        '<span class="sl">'+esc(s[1])+'</span>'+
        '<span class="sq">'+
          '<button type="button" class="sb" data-tee="'+s[0]+'" data-d="-1" '+(n?"":"disabled")+' aria-label="One fewer '+esc(s[1])+'">−</button>'+
          '<span class="sn">'+n+'</span>'+
          '<button type="button" class="sb" data-tee="'+s[0]+'" data-d="1" '+(full?"disabled":"")+' aria-label="One more '+esc(s[1])+'">+</button>'+
        '</span>'+
      '</div>';
    }).join("")+
    '<div class="tf-size-tot'+(full?" full":"")+'">'+total+' of '+MAX_TEES+' shirts'+
      (full?' · that\'s the limit':"")+'</div></div>';
  }
  if(st.type==="choice"){
    var keys=["A","B","C","D"];
    return '<div class="tf-opts">'+BIZ.map(function(o,b){
      return '<button type="button" class="tf-opt '+(f.type===o[0]?"on":"")+'" data-type="'+o[0]+'">'+
        '<span class="key">'+keys[b]+'</span>'+
        '<span><span class="ot">'+esc(o[1])+'</span><span class="od">'+esc(o[2])+'</span></span></button>';
    }).join("")+'</div>';
  }
  if(st.type==="address"){
    return '<div class="tf-addr">'+
      /* position:relative anchor for the suggestion dropdown. */
      '<div class="tf-acwrap">'+
        '<input class="tf-in" placeholder="Street address" autocomplete="street-address" value="'+esc(f.addr||"")+'" data-f="addr" data-ac="1" autocapitalize="words">'+
        '<div class="acsug" id="acsug"></div>'+
      '</div>'+
      '<input class="tf-in" placeholder="Suite, unit (optional)" autocomplete="address-line2" value="'+esc(f.addr2||"")+'" data-f="addr2">'+
      '<div class="tf-addr-row">'+
        '<input class="tf-in" placeholder="City" autocomplete="address-level2" value="'+esc(f.city||"")+'" data-f="city">'+
        '<input class="tf-in" placeholder="State" autocomplete="address-level1" maxlength="20" value="'+esc(f.state||"")+'" data-f="state">'+
        '<input class="tf-in" placeholder="ZIP" inputmode="numeric" autocomplete="postal-code" maxlength="10" value="'+esc(f.zip||"")+'" data-f="zip">'+
      '</div>'+
      addrPanel()+
      (S.addrChecking?'<div class="tf-mini" style="margin-top:12px;color:var(--gold-deep);font-weight:700">Checking the address…</div>':"")+
    '</div>';
  }
  if(st.type==="long"){
    return '<textarea class="tf-in" rows="4" placeholder="'+esc(st.ph||"")+'" data-f="'+st.k+'">'+esc(f[st.k]||"")+'</textarea>';
  }
  if(st.type==="confirm"){
    var list = picked();
    return '<div class="tf-kit"><b>Your Marketing Box — '+list.length+' '+(list.length===1?"piece":"pieces")+'</b>'+
             '<div class="list">'+esc(list.join(" · "))+'</div>'+
             /* Sizes are the one thing on this screen a retailer might want to fix
                before sending, so they get repeated rather than left three steps back. */
             (teeSummary() ? '<div class="list">T-shirts: '+esc(teeSummary())+'</div>' : "")+
           '</div>'+
           '<div class="tf-check"><input type="checkbox" id="f_age" '+(f.age?"checked":"")+' data-f="age">'+
             '<label for="f_age">I’m 21 or older and ordering for a licensed business.</label></div>'+
           '<div class="tf-check tf-consent"><input type="checkbox" id="f_opt" '+(f.consent?"checked":"")+' data-f="consent">'+
             '<label for="f_opt">Email me retailer pricing, new flavors and order updates.'+
             '<span class="cmini">Optional. Unsubscribe any time.</span></label></div>'+
           (S.sending?'<div class="tf-mini" style="color:var(--gold-deep);font-weight:700">Sending your request…</div>':"");
  }
  var mode = st.mode ? ' inputmode="'+st.mode+'"' : (st.type==="tel" ? ' inputmode="tel"' : "");
  var auto = st.k==="email" ? ' autocomplete="email"' : (st.k==="phone" ? ' autocomplete="tel"' :
             (st.k==="biz" ? ' autocomplete="organization"' : (st.k==="contact" ? ' autocomplete="name"' : "")));
  return '<input class="tf-in" type="'+(st.type==="text"?"text":st.type)+'"'+mode+auto+
         ' placeholder="'+esc(st.ph||"")+'" value="'+esc(f[st.k]||"")+'" data-f="'+st.k+'">';
}

function form(){
  var ST = steps();
  var N = ST.length;
  var i = Math.max(0, Math.min(S.step, N-1));
  var st = ST[i], last = (i === N-1);
  var acts;
  if(st.type==="choice"){
    acts = '<span class="tf-hint">Tap one to continue</span>';
  } else {
    acts = '<button class="tf-ok" data-act="next"'+(S.sending?" disabled":"")+'>'+
             (last ? "Send my kit request" : "OK")+' <span class="k">↵</span></button>'+
           (st.opt ? '<button class="tf-skip" data-act="skip">Skip</button>' : "")+
           '<span class="tf-hint">press <b>Enter ↵</b></span>';
  }
  return '<div class="tf">'+
    '<div class="tf-bar"><span style="width:'+Math.round((i+1)/N*100)+'%"></span></div>'+
    '<div class="tf-top"><span class="lg">KING PALM</span>'+
      '<div class="r"><span class="count">'+(i+1)+' → '+N+'</span>'+
      '<button class="x" data-act="exit" aria-label="Close">✕</button></div></div>'+
    '<div class="tf-body"><div class="tf-card">'+
      '<div class="tf-q">'+esc(st.q)+(st.opt?'<span class="opt">optional</span>':"")+'</div>'+
      (st.sub?'<div class="tf-sub">'+esc(st.sub)+'</div>':"")+
      stepCtrl(st)+
      (S.err?'<div class="tf-err" role="alert">'+esc(S.err)+'</div>':"")+
      '<div class="tf-actions">'+acts+'</div>'+
      (i>0?'<button class="tf-back" data-act="back">↑ Back</button>':"")+
    '</div></div>'+
  '</div>';
}

function done(){
  var list = picked();
  return '<div class="tf"><div class="tf-bar"><span style="width:100%"></span></div>'+
    '<div class="tf-top"><span class="lg">KING PALM</span></div>'+
    '<div class="tf-body"><div class="done-wrap">'+
      '<div class="done-mark">✓</div>'+
      '<h2>Your kit is on the way.</h2>'+
      '<p>We’ve got it, '+esc(S.form.contact||"")+'. Your box ships to '+
        esc(S.form.biz||"your shop")+' with your next order — we’ll email '+
        esc(S.form.email||"you")+' with tracking.</p>'+
      '<div class="done-sum"><div class="t">In your box</div><div class="chips">'+
        list.map(function(l){return '<span class="chip">'+esc(l)+'</span>';}).join("")+
      '</div></div>'+
      '<div class="tf-actions" style="justify-content:center">'+
        '<a class="btn btn-ghost" href="/">Back to King Palm</a>'+
      '</div>'+
    '</div></div></div>';
}

/* ============================================================================
   RENDER + EVENTS
   ========================================================================== */
function render(){
  var html = S.stage==="picker" ? picker()
           : S.stage==="form"   ? form()
           : S.stage==="done"   ? done()
           : home();
  app.innerHTML = html;
  document.body.style.overflow = (S.stage==="form"||S.stage==="done") ? "hidden" : "";
  var first = app.querySelector(".tf-in");
  if(first && S.stage==="form") setTimeout(function(){ first.focus(); }, 60);
}

function syncInputs(){
  var nodes = app.querySelectorAll("[data-f]");
  for(var i=0;i<nodes.length;i++){
    var n = nodes[i], k = n.getAttribute("data-f");
    S.form[k] = (n.type==="checkbox") ? n.checked : n.value;
  }
}

/* Validation lives next to the step definition rather than in one big switch, so
   adding a question can't silently ship without a rule. */
function validate(st){
  var f = S.form;
  if(!st.req) return "";
  if(st.type==="choice")  return f.type ? "" : "Pick the closest one.";
  if(st.type==="address") {
    if(!f.addr)  return "We need a street address to ship to.";
    if(!f.city)  return "Which city?";
    if(!f.state) return "Which state?";
    if(!/^\d{5}(-\d{4})?$/.test(String(f.zip||"").trim())) return "That ZIP doesn't look right.";
    return "";
  }
  if(st.type==="sizes"){
    var t = teeTotal();
    if(!t) return "Pick at least one shirt.";
    if(t > MAX_TEES) return "That's more than "+MAX_TEES+" shirts.";
    return "";
  }
  if(st.type==="confirm") return f.age ? "" : "Tick the box to confirm you're 21+ and a licensed business.";
  var v = String(f[st.k]||"").trim();
  if(!v) return "This one's required.";
  if(st.k==="email" && !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v)) return "That email doesn't look right.";
  if(st.k==="phone" && String(v).replace(/\D/g,"").length < 10) return "That number looks too short.";
  return "";
}

function next(){
  syncInputs();
  var st = steps()[S.step];
  var err = validate(st);
  if(err){ S.err = err; render(); return; }
  S.err = "";
  /* The address gets verified once per distinct address. addrCheckFor remembers
     which one was cleared, so tapping OK again on an unchanged address does not
     re-ask Google — and editing it after clearing DOES. */
  if(st.type==="address" && addrCheckNeeded()){ checkAddress(tfAdvance); return; }
  tfAdvance();
}
function addrCheckNeeded(){ return S.addrCheckFor !== addrKey(); }
function tfAdvance(){
  S.err=""; S.addrCheck=null;
  if(S.step >= steps().length-1){ submit(); return; }
  S.step++; render();
}
function useSuggestedAddr(){
  var s=(S.addrCheck&&S.addrCheck.suggested)||{};
  if(s.address1) S.form.addr=s.address1;
  if(s.address2) S.form.addr2=s.address2;
  if(s.city)     S.form.city=s.city;
  if(s.state)    S.form.state=s.state;
  if(s.zip)      S.form.zip=s.zip;
  S.addrCheckFor=addrKey();
  tfAdvance();
}
function keepTypedAddr(){ S.addrCheckFor=addrKey(); tfAdvance(); }

function submit(){
  if(S.sending) return;
  S.sending = true; render();
  var payload = {
    source:"kingpalm.com/pages/store-kit",
    submittedAt:new Date().toISOString(),
    shop:{
      name:S.form.biz, type:S.form.type, locations:S.form.locations,
      contact:S.form.contact, email:S.form.email, phone:S.form.phone
    },
    /* One address, used for both shipping and mailing. */
    address:{
      line1:S.form.addr, line2:S.form.addr2, city:S.form.city,
      state:S.form.state, zip:S.form.zip, country:"United States"
    },
    sourcing:{ orderFrom:S.form.source, displaysCarried:S.form.displays },
    experience:S.form.exp || "",
    marketingBox:picked(),
    /* Only sent when a shirt is in the box. The API treats an absent value as
       'old cached form' and falls back to one unsized shirt, so sending {} for a
       kit with no T-shirt would be a lie it has to reject. */
    tshirtSizes:(picked().indexOf('T-shirt')>-1 ? tees() : undefined),
    consent:{ ageConfirmed:!!S.form.age, emailOptIn:!!S.form.consent }
  };
  var endpoint = window.KP_STORE_KIT_ENDPOINT || "";
  if(!endpoint){
    /* No endpoint wired yet (prototype). Show the flow completing and log the
       exact payload the webhook will receive, so the shape can be reviewed
       before anything is posted anywhere. */
    console.log("[store-kit] payload (no endpoint configured):", payload);
    S.sending = false; S.stage = "done"; render(); return;
  }
  fetch(endpoint,{
    method:"POST",
    headers:{"Content-Type":"application/json"},
    body:JSON.stringify(payload)
  }).then(function(r){ return r.ok ? r.json().catch(function(){return {ok:true};}) : Promise.reject(r.status); })
    .then(function(){ S.sending=false; S.stage="done"; render(); })
    .catch(function(){
      /* Never strand a retailer on a failed POST — they filled in eleven screens.
         Show the confirmation, and let the server-side retry own delivery. */
      console.error("[store-kit] submit failed; payload:", payload);
      S.sending=false; S.stage="done"; render();
    });
}

app.addEventListener("click", function(e){
  var t;
  if((t = e.target.closest("[data-go]"))){
    var g = t.getAttribute("data-go");
    if(g==="form"){ if(!count()) return; S.step=0; S.err=""; }
    S.stage = g; render(); window.scrollTo(0,0); return;
  }
  if((t = e.target.closest("[data-mbox]"))){
    var lbl = t.getAttribute("data-mbox");
    S.mats[lbl] = !S.mats[lbl];
    render(); return;
  }
  if((t = e.target.closest("[data-acpick]"))){
    acPick(t.getAttribute("data-acpick")); return;
  }
  if((t = e.target.closest("[data-tee]"))){
    var sz = t.getAttribute("data-tee"), d = parseInt(t.getAttribute("data-d"),10);
    var cur = parseInt(tees()[sz],10)||0, want = cur + d;
    /* Clamp rather than refuse. The + is already disabled at the cap, so reaching
       here means a keyboard or a double-tap raced the re-render — silently holding
       the line is better than an error the retailer did not earn. */
    if(want < 0) want = 0;
    if(d > 0 && teeTotal() >= MAX_TEES) want = cur;
    tees()[sz] = want; S.err="";
    render(); return;
  }
  if((t = e.target.closest("[data-type]"))){
    S.form.type = t.getAttribute("data-type"); S.err="";
    if(S.step < steps().length-1){ S.step++; }
    render(); return;
  }
  if((t = e.target.closest("[data-act]"))){
    var a = t.getAttribute("data-act");
    if(a==="next"){ next(); return; }
    if(a==="addr-use"){ useSuggestedAddr(); return; }
    if(a==="addr-keep"){ keepTypedAddr(); return; }
    if(a==="skip"){ syncInputs(); S.err=""; S.step++; render(); return; }
    if(a==="back"){ syncInputs(); S.err=""; if(S.step>0) S.step--; render(); return; }
    if(a==="exit"){ syncInputs(); S.stage="picker"; render(); window.scrollTo(0,0); return; }
  }
});

/* Delegated so it survives every re-render — the address step is rebuilt from
   scratch on each keystroke elsewhere in the flow. */
app.addEventListener("input", function(e){
  var el = e.target;
  if(el && el.getAttribute && el.getAttribute("data-ac")){ acSuggest(el.value); }
});

app.addEventListener("keydown", function(e){
  if(S.stage!=="form") return;
  if(e.key!=="Enter") return;
  /* Enter submits the step, except inside the long-form answer where a retailer
     is writing sentences and expects a newline. */
  if(e.target.tagName==="TEXTAREA" && !e.metaKey && !e.ctrlKey) return;
  e.preventDefault(); next();
});

render();
})();
